/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Text_HelpInputs */

const en_import_text_help = /** @type {(inputs: Import_Text_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingredients and steps in any order: we'll sort them.`)
};

const de_import_text_help = /** @type {(inputs: Import_Text_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zutaten und Schritte in beliebiger Reihenfolge: wir sortieren sie.`)
};

/**
* | output |
* | --- |
* | "Ingredients and steps in any order: we'll sort them." |
*
* @param {Import_Text_HelpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_text_help = /** @type {((inputs?: Import_Text_HelpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Text_HelpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_text_help(inputs)
	return en_import_text_help(inputs)
});